import { Link } from "react-router-dom";
import { useUiLabels } from "../labels/LabelsContext";
import "./styles/index.scss";

// One thin row of service links (contacts, version history, privacy, cookies).
// links: [{ label, link }], label keys translated through the LabelsProvider.
const Footer = ({ links }) => {
  const [getLabel] = useUiLabels();
  if (!Array.isArray(links) || links.length === 0) return null;

  return (
    <footer className="footer_container">
      <div className="footer">
        {links.map((l, i) => (
          <Link
            key={`footer-link-${i}`}
            to={l?.link || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            {getLabel(l?.label)}
          </Link>
        ))}
      </div>
    </footer>
  );
};

export default Footer;
